.dealFooter {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  border-top: 1px solid var(--ib-line-2);
  /* pin the Risks/Summary/Report footer to the bottom of the card regardless of
     content height (e.g. the shorter Summary view) */
  margin-top: auto;
}
